const DoctorPortal = () => {

    return (
        <>
            <h1>Doctor Portal Page</h1>
        </>
    )

}

export default DoctorPortal;